import { useMediaQuery, Typography, Stepper, Step, StepLabel, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CompleteRegisterStepOneForm, CompleteRegisterStepTwoForm } from '../../forms';
import { acPostCompleteRegister, acGetCustomer } from '../../store/actions';
import { PanelBox } from '../default';

/**
 * Renders a form for completing user registration.
 *
 * @author Maria Eduarda Franke, Isadora Botassari
 * @param {Object} setSnackbarData - Function to set snackbar data.
 * @returns {JSX.Element} The rendered form component.
 */
export const CompleteRegisterForm = ({ setSnackbarData }) => {

    const dispatch = useDispatch()

    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'))

    const completeRegisterData = useSelector(state => state.customer.completeRegisterData)

    const steps = ['Alterar Senha', 'Completar Informações Pessoais']

    const [activeStep, setActiveStep] = useState(0)

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
    }

    const handleSubmit = ({ firstName, lastName, phone }) => {

        dispatch(acPostCompleteRegister({
            ...completeRegisterData,
            firstName,
            lastName,
            phone,
            plan: 1
        }))
            .then(() => {
                setSnackbarData({ open: true, message: 'Cadastro finalizado com sucesso!' })
                dispatch(acGetCustomer())
                    .catch(error => console.error(error))
            })
            .catch(error => console.error(error))
    }

    return (
        <PanelBox title='Complete seu Cadastro'>

            {/* Stepper */}
            <Paper sx={{ p: 3 }}>

                {!isMobile && (
                    <Stepper activeStep={activeStep} sx={{ mb: 2 }}>
                        {
                            steps.map((label) => {
                                return (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                )
                            })
                        }
                    </Stepper>
                )}

                {isMobile && (
                    <Typography variant='h8' textAlign='center' color='text.secondary' sx={{ mb: 4 }}>
                        {steps[activeStep]}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <CompleteRegisterStepOneForm
                        completeRegisterData={completeRegisterData}
                        handleNext={handleNext}
                        isMobile={isMobile}
                    />
                )}
                {activeStep === 1 && (
                    <CompleteRegisterStepTwoForm
                        completeRegisterData={completeRegisterData}
                        handleBack={handleBack}
                        handleFinish={handleSubmit}
                        isMobile={isMobile}
                    />
                )}

            </Paper>
        </PanelBox>
    )

}

CompleteRegisterForm.propTypes = {
    setSnackbarData: PropTypes.func.isRequired
}
